'use client';

import React, { useEffect, useRef, useState } from 'react';
import { mapModifiers, scrollToElement } from '@/utils/funtion';
import IndicatorSession from '@/components/templates/indicator-session';
import { useSearchParams } from 'next/navigation';
import { SCREEN } from '@/statics/constants';
import LazyComponent from '@/components/molecules/lazyComponent';
import { ISlugs } from '@/stores/modules/slugs';

interface IProps {
  slugs: any;
}

function IndustryDataModule(props: IProps) {
  const searchParams = useSearchParams();
  const { slugs } = props;
  const [loading, setLoading] = useState<Record<string, boolean>>({});
  const slug = searchParams?.get('slug');
  const [hasScroll, setHasScroll] = useState(true);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    if (slug) {
      setHasScroll(true);
    }
  }, [slug]);

  useEffect(() => {
    if (slug && !loading[slug] && hasScroll) {
      const element = document.getElementById(slug) as HTMLElement | null;
      if (element) {
        scrollToElement(element);
        if (observerRef.current) {
          observerRef.current.disconnect();
        }
        observerRef.current = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                setHasScroll(false);
                observerRef.current?.disconnect();
              }
            });
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
          },
        );

        observerRef.current.observe(element);
      }
    }
  }, [slug, loading, hasScroll]);

  const handleLoadingChange = (slug: string, isLoading: boolean) => {
    setLoading((prev) => ({
      ...prev,
      [slug]: isLoading,
    }));
  };

  return (
    <div className={mapModifiers('indicator-data-module')}>
      <div className="indicator-data-wrapper">
        <div className="indicator-data-title page-title">
          Dữ liệu kinh tế ngành
        </div>
        {slugs?.length > 0 &&
          slugs?.map((item: ISlugs, index: number) => (
            <div key={index} id={item?.slug}>
              <LazyComponent>
                <IndicatorSession
                  screen={SCREEN.INDUSTRY}
                  slug={item?.slug}
                  onLoadingChange={(isLoading) => {
                    handleLoadingChange(item?.slug, isLoading);
                  }}
                />
              </LazyComponent>
            </div>
          ))}
      </div>
    </div>
  );
}

export default IndustryDataModule;
